export default "__VITE_ASSET__BfMFSbWg__"